export default "__VITE_ASSET__522e9c20__"